import React, { FunctionComponent, useCallback } from 'react';
import styles from './DescriptionColumns.module.scss';
import { Block, BlockContent, BlockHeader, DescriptionTile, Typography } from 'components/elements';
import { WPAcfDescriptionColumn, WPAcfDescriptionColumns, WPAcfDescriptionItem } from 'types/acf/description';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useCurrentWidth } from 'hooks/dom';
import { isMobile } from 'utils';

interface OwnProps {
  data: WPAcfDescriptionColumns | null;
}

type DescriptionColumnsProps = JSX.IntrinsicElements['div'] & OwnProps;

const DescriptionColumns: FunctionComponent<DescriptionColumnsProps> = props => {
  const { data } = props;
  const [tileHeight, setTileHeight] = useState(0);
  const containerRef = useRef();
  const windowWidth = useCurrentWidth();

  const selectBiggest = () => {
    let height = 0;
    document.querySelectorAll('[data-type="description-tile"]').forEach((item: Element) => {
      if (item.clientHeight > height) {
        height = item.clientHeight;
      }
    });
    return height;
  };

  const wrapperRef = useCallback(node => {
    if (node && !isMobile()) {
      containerRef.current = node;
      setTileHeight(selectBiggest());
    }
  }, []);

  useEffect(() => {
    if (containerRef?.current && !isMobile()) {
      setTileHeight(selectBiggest());
    }
  }, [windowWidth, data, containerRef]);

  if (!data) {
    return null;
  }

  const { header, columns } = data;

  const renderColumns = (columns: WPAcfDescriptionColumn[]) => {
    const filteredItems = columns.filter(item => item.header || item.items);
    const [list, chunkSize] = [[...filteredItems], 3];
    const chunks = [...Array(Math.ceil(list.length / chunkSize))].map(_ => list.splice(0, chunkSize));

    return chunks.map((chunk, chunkIndex) => {
      const columnsLength = chunk && chunk.length;

      if (!columnsLength) {
        return null;
      }

      return chunk.map((column: WPAcfDescriptionColumn, index) => (
        <div key={`description-column-${chunkIndex}-${index}`} className={styles.column}>
          <Typography as="h3" className={styles.columnHeader} mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2">
            {column.header}
          </Typography>
          <div className={styles.columnContent}>
            {column?.items && column.items.map((item: WPAcfDescriptionItem) => <DescriptionTile tileHeight={tileHeight} data={item} key={item.header} />)}
          </div>
        </div>
      ));
    });
  };

  return (
    <Block id="description-columns" data-module="description-columns">
      <BlockContent direction="row" ref={wrapperRef} className={styles.container}>
        {header && <BlockHeader className={styles.header}>{header}</BlockHeader>}
        {columns && renderColumns(columns)}
      </BlockContent>
    </Block>
  );
};

export default DescriptionColumns;
